import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "./Map.scss"; // Asegúrate que define altura

// Corrige íconos de Leaflet en React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
    iconUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

// Mueve la vista al recibir nuevas coordenadas
// eslint-disable-next-line react-hooks/exhaustive-deps
const ChangeMapView = ({ coords }) => {
    const map = useMap();

    useEffect(() => {
        if (Array.isArray(coords) && coords.length === 2) {
            map.setView(coords, 18);
        }
    }, [coords, map]);

    return null;
};

const parseCoords = (coords) => {
    if (!coords) return null;

    if (Array.isArray(coords) && coords.length === 2) {
        return [parseFloat(coords[0]), parseFloat(coords[1])];
    }

    if (
        typeof coords === "object" &&
        coords.lat !== undefined &&
        coords.lon !== undefined
    ) {
        return [parseFloat(coords.lat), parseFloat(coords.lon)];
    }

    return null;
};

const Map = ({ coords }) => {
    const parsedCoords = parseCoords(coords);
    const defaultCoords = [20.6773, -103.347];

    return (
        <div className="Map">
            <MapContainer
                center={parsedCoords || defaultCoords}
                zoom={18}
                scrollWheelZoom={false}
                className="container_map"
                style={{ height: "100%", width: "100%" }}
            >
                <TileLayer
                    attribution="&copy; OpenStreetMap contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {parsedCoords && (
                    <>
                        <ChangeMapView coords={parsedCoords} />
                        <Marker position={parsedCoords}>
                            <Popup>Ubicación localizada</Popup>
                        </Marker>
                    </>
                )}
            </MapContainer>
        </div>
    );
};

export default Map;
